import { normalizeCartItems } from '../utils/cartNormalizer';

let initialState = [];

if (typeof window !== "undefined") {
  if (localStorage.getItem("cart")) {
    const rawCart = JSON.parse(localStorage.getItem("cart"));
    initialState = normalizeCartItems(rawCart);
  } else {
    initialState = [];
  }
}

export const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_TO_CART":
      // Just return the cart array as-is
      return normalizeCartItems(action.payload);
    default:
      return state;
  };
};
